<div class="m-3">
  <h1> Workers' Compensation Exemption Registration</h1>
</div>

<div class="row">
  <div class="col-3"></div>
  <div class="col-2">
    <h2>Thank you!</h2>
  </div>
  <div class="col-4">
    <p style="color: red;font-weight: bold; text-align: center;margin-top: 10px"> Application Status = Pending review by
      BWC</p>
  </div>

</div>


<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Payment Receipt #
  </div>
  <div class="col-4">{{fisPaymentData?.fisTransactionId}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Registration Fee Paid
  </div>
  <div class="col-4">${{fisPaymentData?.amount}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Payment Type
  </div>
  <div class="col-4">{{fisPaymentData?.fisPaymentType}}</div>
</div>
<div class="row" style="margin-top: 10px;">
  <div class="col-3"></div>
  <div class="col-2">
    <h2>Contact Info</h2>
  </div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Name
  </div>
  <div class="col-4">{{data?.firstName + ' ' + data?.lastName}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Address
  </div>
  <div class="col-4">{{data?.mailingAddress?.address1}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">City
  </div>
  <div class="col-4">{{data?.mailingAddress?.city}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">State
  </div>
  <div class="col-4">{{data?.mailingAddress?.state?.abbrv}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Zip
  </div>
  <div class="col-4">{{data?.mailingAddress?.zipCode}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Email
  </div>
  <div class="col-4">{{data?.contactEmail}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Phone
  </div>
  <div class="col-4">{{data?.contactPhone}}</div>
</div>

<div class="row" style="margin-top: 10px;">
  <div class="col-3"></div>
  <div class="col-2">
    <h2>Billing Info</h2>
  </div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Name
  </div>
  <div class="col-4">{{fisPaymentData?.fisBillingName}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Address
  </div>
  <div class="col-4">{{fisPaymentData?.fisBillingAddress}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">City
  </div>
  <div class="col-4">{{fisPaymentData?.fisBillingCity}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">State
  </div>
  <div class="col-4">{{fisPaymentData?.fisBillingState}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Zip
  </div>
  <div class="col-4">{{fisPaymentData?.fisBillingZip}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Email
  </div>
  <div class="col-4">{{fisPaymentData?.fisBillingEmail}}</div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-4">Phone
  </div>
  <div class="col-4">{{fisPaymentData?.fisBillingPhone}}</div>
</div>



<div class="row" style="margin-top: 20px;margin-bottom: 130px;">
  <div class="col-3"></div>
  <div class="col-2">
    <button (click)="onClose()" mat-raised-button color="primary" style="min-width: 150px">Close</button>
  </div>

</div>